import { defineMessages } from 'react-intl';

export const i18n: {
	attachedDateLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	attachmentLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pdfLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	videoLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	imageLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	audioLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	attachedDateLabel: {
		id: 'relay.search-result.attachments.attached-date.label',
		defaultMessage: 'Attached {formattedDate}',
		description: 'Indicates the date the attachment was added',
	},
	attachmentLabel: {
		id: 'relay.search-result.attachment-label',
		defaultMessage: 'Attachment',
		description:
			'Badge label shown on a message attachment search result to identify it as a generic file attachment.',
	},
	pdfLabel: {
		id: 'relay.search-result.attachments.pdf-label',
		defaultMessage: 'PDF',
		description:
			'Badge label shown on a message attachment search result to identify it as a PDF file.',
	},
	videoLabel: {
		id: 'relay.search-result.attachments.video-label',
		defaultMessage: 'Video',
		description:
			'Badge label shown on a message attachment search result to identify it as a video file.',
	},
	imageLabel: {
		id: 'relay.search-result.attachments.image-label',
		defaultMessage: 'Image',
		description:
			'Badge label shown on a message attachment search result to identify it as an image file.',
	},
	audioLabel: {
		id: 'relay.search-result.attachments.audio-label',
		defaultMessage: 'Audio',
		description:
			'Badge label shown on a message attachment search result to identify it as an audio file.',
	},
});
